import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import autobind from 'autobind-decorator'
import * as SaveStatus from '../../constants/SaveStatus'
import * as SaveStatusLabel from '../../constants/SaveStatusLabel'
import HistoryBlockChain from '../../lib/HistoryBlockChain'

class TSubmitButtonForm extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      changedStatus: false,
      statusLabel: props.label || SaveStatusLabel
    }
  }

  componentWillMount() {
    HistoryBlockChain.add(this.blockChangeLocation)
  }

  componentWillUnmount() {
    HistoryBlockChain.remove(this.blockChangeLocation)
  }

  @autobind
  blockChangeLocation(nextLocation, lastAction) {
    const { status } = this.props
    if (status === SaveStatus.CAN_SUBMIT) {
      return "변경사항을 저장하지 않고 페이지를 이동하시겠습니까?"
    }
  }

  componentWillReceiveProps(nextProps) {

    if((this.props.status === SaveStatus.READY) && (nextProps.status === SaveStatus.CAN_SUBMIT)) {
      this.setState({changedStatus : true});
    }

  }

  renderClassName() {
    const { status } = this.props
    return classnames("btn_save", {
      "btn_off": status === SaveStatus.READY,
      "btn_doing": status === SaveStatus.DOING,
      "btn_over": status === SaveStatus.DONE
    })
  }

  renderMessage() {
    const { status, active } = this.props;
    const { changedStatus, statusLabel } = this.state;
    switch(status) {
      case SaveStatus.DOING:
        return statusLabel.DOING
      case SaveStatus.DONE:
        return statusLabel.DONE
      default:
        if(active){
          if(changedStatus) {
            return statusLabel.CAN_SUBMIT
          }
        }
        return statusLabel.READY
    }
  }

  render() {
    const { status, type, onClick } = this.props

    return (
      <button type={type} className={this.renderClassName()} disabled={status !== SaveStatus.CAN_SUBMIT} onClick={onClick}>
        { this.renderMessage() }
      </button>
    )
  }
}

TSubmitButtonForm.propTypes = {
  status: PropTypes.string,
  label: PropTypes.object,
  active: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func
}

TSubmitButtonForm.defaultProps = {
  active: true,
  type: "button"
}

export default TSubmitButtonForm
